export default __webpack_public_path__ + "static/media/36I-102747_-17363_0.7243f49e.jpg";